"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.some.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.splice.js");

var _input = _interopRequireDefault(require("element-ui/lib/input"));

var _scrollbar = _interopRequireDefault(require("element-ui/lib/scrollbar"));

var _tag = _interopRequireDefault(require("element-ui/lib/tag"));

var _tooltip = _interopRequireDefault(require("element-ui/lib/tooltip"));

var _locale = require("element-ui/lib/locale");

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var _focus = _interopRequireDefault(require("element-ui/lib/mixins/focus"));

var _locale2 = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var _clickoutside = _interopRequireDefault(require("element-ui/lib/utils/clickoutside"));

var _dom = require("element-ui/lib/utils/dom");

var _resizeEvent = require("element-ui/lib/utils/resize-event");

var _scrollIntoView = _interopRequireDefault(require("element-ui/lib/utils/scroll-into-view"));

var _shared = require("element-ui/lib/utils/shared");

var _util = require("element-ui/lib/utils/util");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _navigationMixin = _interopRequireDefault(require("./navigation-mixin"));

var _option = _interopRequireDefault(require("./option"));

var _selectDropdown = _interopRequireDefault(require("./select-dropdown"));

/** 扩展 */
// import directive from 'element-ui/packages/tooltip/src/directive';

/** */
var sizeMap = {
  medium: 36,
  small: 32,
  mini: 28
};

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: _vm.handleClose,
      expression: "handleClose"
    }],
    staticClass: "el-select",
    "class": [_vm.selectSize ? 'el-select--' + _vm.selectSize : '', {
      'is-without-arrow-icon': !_vm.showArrowIcon
    }],
    attrs: {},
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleMenu($event);
      }
    }
  }, [_vm.multiple ? _c('div', {
    ref: "tags",
    staticClass: "el-select__tags",
    style: _vm._px2rem(_vm.tagsStyle, 24, ['maxWidth', 'max-width']),
    attrs: {
      "conversionForbiddenPx2Rem": "maxWidth,max-width"
    }
  }, [_vm.collapseTags && _vm.selected.length ? _c('span', [_c('el-tag', {
    attrs: {
      "closable": !_vm.selectDisabled,
      "size": _vm.collapseTagSize,
      "hit": _vm.selected[0].hitState,
      "type": "info",
      "disable-transitions": ""
    },
    on: {
      "close": function close($event) {
        _vm.deleteTag($event, _vm.selected[0]);
      }
    }
  }, [_c('span', {
    staticClass: "el-select__tags-text",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.selected[0].currentLabel))])]), _vm._v(" "), _vm.selected.length > 1 ? _c('el-tag', {
    attrs: {
      "closable": false,
      "size": _vm.collapseTagSize,
      "type": "info",
      "disable-transitions": ""
    }
  }, [_c('span', {
    staticClass: "el-select__tags-text",
    attrs: {}
  }, [_vm._v("+ " + _vm._s(_vm.selected.length - 1))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !_vm.collapseTags ? _c('transition-group', {
    "class": {
      'el-select__tags-lists': _vm.showOverflowTip
    },
    style: _vm._px2rem(_vm.transitionGroupStyle, 24, ['width']),
    attrs: {
      "conversionForbiddenPx2Rem": "width"
    },
    on: {
      "after-leave": _vm.resetInputHeight
    }
  }, _vm._l(_vm.selected, function (item) {
    return _c('el-tag', {
      key: _vm.getValueKey(item),
      attrs: {
        "closable": !_vm.selectDisabled,
        "size": _vm.collapseTagSize,
        "hit": item.hitState,
        "type": "info",
        "disable-transitions": ""
      },
      on: {
        "close": function close($event) {
          _vm.deleteTag($event, item);
        }
      }
    }, [_vm.showOverflowTip ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.overflow",
        modifiers: {
          "overflow": true
        }
      }],
      staticClass: "el-select__tags-text",
      attrs: {}
    }, [_vm._v(_vm._s(item.currentLabel))]) : _c('span', {
      staticClass: "el-select__tags-text",
      attrs: {}
    }, [_vm._v(_vm._s(item.currentLabel))])]);
  })) : _vm._e(), _vm._v(" "), _vm.filterable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    ref: "input",
    staticClass: "el-select__input",
    "class": [_vm.selectSize ? "is-" + _vm.selectSize : ''],
    style: _vm._px2rem(_vm.inputStyle, 24, ['maxWidth', 'max-width', 'width']),
    attrs: {
      "type": "text",
      "disabled": _vm.selectDisabled,
      "autocomplete": _vm.autoComplete,
      "conversionForbiddenPx2Rem": "maxWidth,max-width,width"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": function blur($event) {
        _vm.softFocus = false;
      },
      "click": function click($event) {
        $event.stopPropagation();
      },
      "keyup": _vm.managePlaceholder,
      "keydown": [_vm.resetInputState, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }

        $event.preventDefault();

        _vm.navigateOptions('next');
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }

        $event.preventDefault();

        _vm.navigateOptions('prev');
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.preventDefault();
        return _vm.selectOption($event);
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false;
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) {
          return null;
        }

        return _vm.deletePrevTag($event);
      }],
      "compositionstart": _vm.handleComposition,
      "compositionupdate": _vm.handleComposition,
      "compositionend": _vm.handleComposition,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.query = $event.target.value;
      }, _vm.debouncedQueryChange]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-input', {
    ref: "reference",
    "class": {
      'is-focus': _vm.visible
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.currentPlaceholder,
      "name": _vm.name,
      "id": _vm.id,
      "auto-complete": _vm.autoComplete,
      "size": _vm.selectSize,
      "disabled": _vm.selectDisabled,
      "readonly": _vm.readonly,
      "validate-event": false
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    },
    nativeOn: {
      "keyup": function keyup($event) {
        return _vm.debouncedOnInputChange($event);
      },
      "keydown": [function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();

        _vm.navigateOptions('next');
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();

        _vm.navigateOptions('prev');
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.preventDefault();
        return _vm.selectOption($event);
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false;
      }, function ($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        _vm.visible = false;
      }],
      "paste": function paste($event) {
        return _vm.debouncedOnInputChange($event);
      },
      "mouseenter": function mouseenter($event) {
        _vm.inputHovering = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.inputHovering = false;
      }
    },
    model: {
      value: _vm.selectedLabel,
      callback: function callback($v) {
        _vm.selectedLabel = $v;
      },
      expression: "selectedLabel"
    }
  }, [_vm.$slots.prefix ? _c('template', {
    attrs: {},
    slot: "prefix"
  }, [_vm._t("prefix", null, {})], 2) : _vm._e(), _vm._v(" "), _vm.showArrowIcon ? _c('i', {
    "class": ['el-select__caret', 'el-input__icon', 'el-icon-' + _vm.iconClass, {
      'el-icon-loading': _vm.loading
    }],
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  }) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    },
    on: {
      "before-enter": _vm.handleMenuEnter,
      "after-leave": _vm.doDestroy
    }
  }, [_c('el-select-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible && _vm.emptyText !== false,
      expression: "visible && emptyText !== false"
    }],
    ref: "popper",
    attrs: {
      "append-to-body": _vm.popperAppendToBody
    }
  }, [_c('el-scrollbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.options.length > 0 && !_vm.loading,
      expression: "options.length > 0 && !loading"
    }],
    ref: "scrollbar",
    "class": {
      'is-empty': !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0
    },
    attrs: {
      "tag": "ul",
      "wrap-class": "el-select-dropdown__wrap",
      "view-class": "el-select-dropdown__list"
    }
  }, [_vm.showNewOption ? _c('el-option', {
    attrs: {
      "value": _vm.query,
      "created": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", null, {})], 2), _vm._v(" "), _vm.emptyText && (!_vm.allowCreate || _vm.loading || _vm.allowCreate && _vm.options.length === 0) ? _c('p', {
    staticClass: "el-select-dropdown__empty",
    attrs: {}
  }, [_vm._v("\n        " + _vm._s(_vm.emptyText) + "\n      ")]) : _vm._e()], 1)], 1)], 1);
};

var __vue_staticRenderFns__ = [];
var _default2 = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  mixins: [_emitter["default"], _locale2["default"], (0, _focus["default"])('reference'), _navigationMixin["default"]],
  name: 'ElSelect',
  componentName: 'ElSelect',
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  provide: function provide() {
    return {
      select: this
    };
  },
  computed: {
    tagsStyle: function tagsStyle() {
      var showArrowIcon = this.showArrowIcon,
          inputWidth = this.inputWidth,
          remSize = this.remSize;
      return {
        'max-width': (showArrowIcon ? inputWidth - remSize(32) : inputWidth - remSize(10)) + 'px'
      };
    },
    transitionGroupStyle: function transitionGroupStyle() {
      var showOverflowTip = this.showOverflowTip,
          showArrowIcon = this.showArrowIcon,
          inputWidth = this.inputWidth,
          remSize = this.remSize;
      return showOverflowTip ? {
        width: (showArrowIcon ? inputWidth - remSize(32) : inputWidth - remSize(10)) + 'px'
      } : {};
    },
    inputStyle: function inputStyle() {
      var inputWidth = this.inputWidth,
          remSize = this.remSize,
          inputLength = this.inputLength;
      return {
        width: inputLength + 'px',
        'max-width': inputWidth - remSize(42) + 'px'
      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly: function readonly() {
      // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
      var isIE = !this.$isServer && !isNaN(Number(document.documentMode));
      return !this.filterable || this.multiple || !isIE && !this.visible;
    },
    iconClass: function iconClass() {
      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && !this.multiple && this.value !== undefined && this.value !== null && this.value !== '';
      return criteria ? 'circle-close is-show-close' : this.remote && this.filterable ? '' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) return false;

        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
          // 扩展 无匹配数据时是否显示提示
          if (!this.showTipWhenEmpty) {
            return false;
          }

          return this.noMatchText || this.t('el.select.noMatch');
        }

        if (this.options.length === 0) {
          // 扩展 无匹配数据时是否显示提示
          if (!this.showTipWhenEmpty) {
            return false;
          }

          return this.noDataText || this.t('el.select.noData');
        }
      }

      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
    }
  },
  components: {
    ElInput: _input["default"],
    ElSelectMenu: _selectDropdown["default"],
    ElOption: _option["default"],
    ElTag: _tag["default"],
    ElScrollbar: _scrollbar["default"]
  },
  directives: {
    Clickoutside: _clickoutside["default"],
    tooltip: _tooltip["default"].directive
  },
  // 扩展
  props: {
    /** 扩展 */
    showOverflowTip: {
      type: Boolean,
      "default": false
    },

    /** */
    name: String,
    id: String,
    value: {
      required: true
    },
    autoComplete: {
      type: String,
      "default": 'off'
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      "default": 0
    },
    placeholder: {
      type: String,
      "default": function _default() {
        return (0, _locale.t)('el.select.placeholder');
      }
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      "default": 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      "default": true
    },

    /** 扩展 无匹配数据时是否显示提示 */
    showTipWhenEmpty: {
      type: Boolean,
      "default": true
    },
    allowCancel: {
      type: Boolean,
      "default": true
    },

    /** 扩展 是否显示arrowIcon */
    showArrowIcon: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      menuVisibleOnFocus: false,
      isOnComposition: false,
      isSilentBlur: false // offset32: toRem ? this._rem2px(32) : 32,
      // offset10: toRem ? this._rem2px(10) : 32

    };
  },
  watch: {
    selectDisabled: function selectDisabled() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.resetInputHeight();
      });
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val, oldVal) {
      if (this.multiple) {
        this.resetInputHeight();

        if (val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }

        if (this.filterable && !this.reserveKeyword) {
          this.query = '';
          this.handleQueryChange(this.query);
        }
      }

      this.setSelected();

      if (this.filterable && !this.multiple) {
        this.inputLength = 20;
      }

      if (!(0, _util.valueEquals)(val, oldVal)) {
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.handleIconHide();
        this.broadcast('ElSelectDropdown', 'destroyPopper');

        if (this.$refs.input) {
          this.$refs.input.blur();
        }

        this.query = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.inputLength = 20;
        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });

        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }

            if (this.filterable) this.query = this.selectedLabel;
          }
        }
      } else {
        this.handleIconShow();
        this.broadcast('ElSelectDropdown', 'updatePopper');

        if (this.filterable) {
          this.query = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.query);

          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }

            this.broadcast('ElInput', 'inputSelect');
          }
        }
      }

      this.$emit('visible-change', val);
    },
    options: function options() {
      var _this4 = this;

      if (this.$isServer) return;
      this.$nextTick(function () {
        _this4.broadcast('ElSelectDropdown', 'updatePopper');
      });

      if (this.multiple) {
        this.resetInputHeight();
      }

      var inputs = this.$el.querySelectorAll('input');

      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }

      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },
  methods: {
    remSize: function remSize(size) {
      return this._rem2px ? this._rem2px(size) : size;
    },
    handleComposition: function handleComposition(event) {
      var text = event.target.value;

      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleQueryChange(text);
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this5 = this;

      if (this.previousQuery === val || this.isOnComposition) return;

      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
        this.previousQuery = val;
        return;
      }

      this.previousQuery = val;
      this.$nextTick(function () {
        if (_this5.visible) _this5.broadcast('ElSelectDropdown', 'updatePopper');
      });
      this.hoverIndex = -1;

      if (this.multiple && this.filterable) {
        var length = this.$refs.input.value.length * 15 + 20;
        this.inputLength = this.collapseTags ? Math.min(50, length) : length;
        this.managePlaceholder();
        this.resetInputHeight();
      }

      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }

      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    handleIconHide: function handleIconHide() {
      var icon = this.$el.querySelector('.el-input__icon');

      if (icon) {
        (0, _dom.removeClass)(icon, 'is-reverse');
      }
    },
    handleIconShow: function handleIconShow() {
      var icon = this.$el.querySelector('.el-input__icon');

      if (icon && !(0, _dom.hasClass)(icon, 'el-icon-circle-close')) {
        (0, _dom.addClass)(icon, 'is-reverse');
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;

      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        (0, _scrollIntoView["default"])(menu, target);
      }

      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this6 = this;

      this.$nextTick(function () {
        return _this6.scrollToOption(_this6.selected);
      });
    },
    emitChange: function emitChange(val) {
      if (!(0, _util.valueEquals)(this.value, val)) {
        this.$emit('change', val);
      }
    },
    getOption: function getOption(value) {
      var option;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';

      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? (0, _util.getValueByPath)(cachedOption.value, this.valueKey) === (0, _util.getValueByPath)(value, this.valueKey) : cachedOption.value === value;

        if (isEqual) {
          option = cachedOption;
          break;
        }
      }

      if (option) return option;
      var label = !isObject && !isNull ? value : '';
      var newOption = {
        value: value,
        currentLabel: label
      };

      if (this.multiple) {
        newOption.hitState = false;
      }

      return newOption;
    },
    setSelected: function setSelected() {
      var _this7 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);

        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }

        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }

      var result = [];

      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this7.getOption(value));
        });
      }

      this.selected = result;
      this.$nextTick(function () {
        _this7.resetInputHeight();
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          this.visible = true;
          this.menuVisibleOnFocus = true;
        }

        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    blur: function blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },
    handleBlur: function handleBlur(event) {
      var _this8 = this;

      setTimeout(function () {
        if (_this8.isSilentBlur) {
          _this8.isSilentBlur = false;
        } else {
          _this8.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleIconClick: function handleIconClick(event) {
      if (this.iconClass.indexOf('circle-close') > -1) {
        this.deleteSelected(event);
      }
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
        this.emitChange(value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
      this.inputLength = this.$refs.input.value.length * 15 + 20;
      this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this9 = this;

      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(function () {
        if (!_this9.$refs.reference) return;
        var inputChildNodes = _this9.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this9.$refs.tags;

        if (tags) {
          if (_this9.beforeTagsClientHeight - 1 === tags.clientHeight || _this9.beforeTagsClientHeight === tags.clientHeight - 1) {
            return;
          }

          _this9.beforeTagsClientHeight = tags.clientHeight;
          var sizeInMap = sizeMap[_this9.selectSize] || 30;
          var sizeMapOffet = 6;

          if (_this9._rem2px) {
            sizeInMap = _this9._rem2px(sizeInMap);
            sizeMapOffet = _this9._rem2px(sizeMapOffet);
          }

          input.style.height = _this9.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? sizeMapOffet : 0) : 0, sizeInMap) + 'px';
        } // if (this._px2rem) {
        //   input.style = this._px2rem(input.style)
        // }


        if (_this9.visible && _this9.emptyText !== false) {
          _this9.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this10 = this;

      setTimeout(function () {
        if (!_this10.multiple) {
          _this10.hoverIndex = _this10.options.indexOf(_this10.selected);
        } else {
          if (_this10.selected.length > 0) {
            _this10.hoverIndex = Math.min.apply(null, _this10.selected.map(function (item) {
              return _this10.options.indexOf(item);
            }));
          } else {
            _this10.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      var _this11 = this;

      if (this.multiple) {
        var value = this.value.slice();
        var optionIndex = this.getValueIndex(value, option.value);

        if (optionIndex > -1) {
          if (this.allowCancel) {
            value.splice(optionIndex, 1);
          }
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }

        this.$emit('input', value);
        this.emitChange(value);

        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }

        if (this.filterable) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }

      this.isSilentBlur = byClick;
      this.setSoftFocus();
      if (this.visible) return;
      this.$nextTick(function () {
        _this11.scrollToOption(option);
      });
    },
    setSoftFocus: function setSoftFocus() {
      this.softFocus = true;
      var input = this.$refs.input || this.$refs.reference;

      if (input) {
        input.focus();
      }
    },
    getValueIndex: function getValueIndex() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments.length > 1 ? arguments[1] : undefined;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';

      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var valueKey = this.valueKey;
        var index = -1;
        arr.some(function (item, i) {
          if ((0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(value, valueKey)) {
            index = i;
            return true;
          }

          return false;
        });
        return index;
      }
    },
    toggleMenu: function toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }

        if (this.visible) {
          ;
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
    selectOption: function selectOption() {
      if (!this.visible) {
        this.toggleMenu();
      } else {
        if (this.options[this.hoverIndex]) {
          this.handleOptionSelect(this.options[this.hoverIndex]);
        }
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      this.$emit('input', '');
      this.emitChange('');
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);

      if (index > -1 && !this.selectDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }

      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable && this.query !== this.selectedLabel) {
        this.query = this.selectedLabel;
        this.handleQueryChange(this.query);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1; // highlight the created option

      var hasCreated = false;

      for (var i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].created) {
          hasCreated = true;
          this.hoverIndex = i;
          break;
        }
      }

      if (hasCreated) return;

      for (var _i = 0; _i !== this.options.length; ++_i) {
        var option = this.options[_i];

        if (this.query) {
          // highlight first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = _i;
            break;
          }
        } else {
          // highlight currently selected option
          if (option.itemSelected) {
            this.hoverIndex = _i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return (0, _util.getValueByPath)(item.value, this.valueKey);
      }
    }
  },
  created: function created() {
    var _this12 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;

    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }

    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.debouncedOnInputChange = (0, _debounce["default"])(this.debounce, function () {
      _this12.onInputChange();
    });
    this.debouncedQueryChange = (0, _debounce["default"])(this.debounce, function (e) {
      _this12.handleQueryChange(e.target.value);
    });
    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
  },
  mounted: function mounted() {
    var _this13 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }

    (0, _resizeEvent.addResizeListener)(this.$el, this.handleResize);

    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }

    this.$nextTick(function () {
      if (_this13.$refs.reference && _this13.$refs.reference.$el) {
        _this13.inputWidth = _this13.$refs.reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) (0, _resizeEvent.removeResizeListener)(this.$el, this.handleResize);
  }
};
exports["default"] = _default2;